import type { Webinar } from '@aulaviva/shared';
import { Alert, Button, DataTable, EmptyState, type ColumnDef } from '@aulaviva/ui';
import { CalendarPlus } from 'lucide-react';
import { useMemo } from 'react';
import { Link, useNavigate } from 'react-router';
import { useWebinarAdmin } from '@/api/admin';
import { formattaIntervalloBreve } from '@/lib/date';
import { admin, comuni } from '@/testi';
import { BadgeWebinar, IntestazioneAdmin } from './comuni';

export function WebinarAdmin() {
  const t = admin.webinar;
  const navigate = useNavigate();
  const webinar = useWebinarAdmin();
  const colonne = useMemo<ColumnDef<Webinar, unknown>[]>(
    () => [
      { header: t.colonne.quando, cell: ({ row }) => formattaIntervalloBreve(row.original.inizioPrevisto, row.original.finePrevista) },
      { header: t.colonne.titolo, cell: ({ row }) => <Link to={`/admin/webinar/${row.original.id}`}>{row.original.titolo}</Link> },
      { header: t.colonne.percorso, cell: ({ row }) => <Link to={`/admin/percorsi/${row.original.percorsoId}`}>{row.original.percorsoTitolo}</Link> },
      { header: t.colonne.stato, cell: ({ row }) => <BadgeWebinar stato={row.original.stato} /> },
      { header: t.colonne.confermati, cell: ({ row }) => t.confermati(row.original.conteggi.confermatiOnline, row.original.conteggi.confermatiSala) },
      { header: t.colonne.ingresso, cell: ({ row }) => admin.modalitaIngresso[row.original.modalitaIngresso] },
    ],
    [t],
  );
  return (
    <>
      <IntestazioneAdmin
        titolo={t.titolo}
        sottotitolo={t.sottotitolo}
        azione={
          <Button variant="primary" icon={CalendarPlus} onClick={() => navigate('/admin/webinar/nuovo')}>
            {t.nuovo}
          </Button>
        }
      />
      {webinar.isError && <Alert variant="error" title={webinar.error.message} action={<Button onClick={() => webinar.refetch()}>{comuni.riprova}</Button>} />}
      <DataTable
        caption={t.titolo}
        columns={colonne}
        data={webinar.data ?? []}
        getRowId={(w) => w.id}
        loading={webinar.isPending}
        testi={admin.comuni}
        empty={
          <EmptyState icon={CalendarPlus} title={t.nessunoTitolo}>
            {t.nessunoTesto}
          </EmptyState>
        }
      />
    </>
  );
}
